<template>
    <DCard padding>
        <DCol>
            <DRow class="mb-3">
                <DCol
                    sm="2"
                    class="pt-1"
                >
                    <DDateFormatInput
                        id="date"
                        v-model="dataFilters.dateFrom"
                        format="YYYY-MM-DD"
                        type="date"
                        :label="__('tools.providerbox.filters.date_from')"
                        class="mb-0"
                        @keydown.enter.exact.prevent="changePage"
                    />
                </DCol>
                <DCol
                    sm="2"
                    class="pt-1"
                >
                    <DDateFormatInput
                        id="date"
                        v-model="dataFilters.dateTo"
                        format="YYYY-MM-DD"
                        type="date"
                        :label="__('tools.providerbox.filters.date_to')"
                        class="mb-0"
                        @keydown.enter.exact.prevent="changePage"
                    />
                </DCol>
                <DCol
                    sm="2"
                    class="pt-1"
                >
                    <label class="form-label">{{ __('tools.providerbox.filters.modules') }}</label>
                    <DMultiSelect
                        :options="moduleOptions"
                        selection-type="tags"
                        :multiple="true"
                        :selection="true"
                        inline
                        @update="updateSelectedModules"
                    />
                </DCol>
                <DCol
                    sm="2"
                    class="pt-1"
                >
                    <DSelect
                        id="status-dropdown"
                        v-model="dataFilters.status"
                        :label="__('tools.providerbox.filters.status')"
                        :options="status"
                    />
                </DCol>
                <DCol
                    sm="2"
                    class="pt-1"
                >
                    <DInput
                        id="customer-id"
                        v-model="dataFilters.customerId"
                        :label="__('tools.providerbox.filters.customer_id')"
                        class="mb-0"
                        @keydown.enter.exact.prevent="changePage"
                    />
                </DCol>
            </DRow>
            <DRow class="mb-3">
                <DCol
                    sm="3"
                    class="d-flex gap-2"
                >
                    <DButton
                        id="filter-apply"
                        :label="__('tools.providerbox.filters.filter')"
                        @click="changePage"
                    />
                    <DButton
                        id="filter-reset"
                        icon="filter-off"
                        :label="__('messages.actions.reset_filter')"
                        @click="resetFilters"
                    />
                </DCol>
            </DRow>
        </DCol>
        <div
            v-if="newImportedItems"
            class="absolute-checkbox"
        >
            <CFormCheck
                id="absolute-checkbox-id"
                v-model:checked="allItems"
                @change="updateAllCheckboxes"
            />
        </div>
        <DTable
            :items="importedItems"
            :fields="fields"
            hover
        >
            <template #checkbox="{item}">
                <td>
                    <CFormCheck
                        v-if="item.status==='new'"
                        :id="item.external_id"
                        :checked="form.items.includes(item.id)"
                        @change="updateCheckboxArray(item.id)"
                    />
                </td>
            </template>
            <template #price="{item}">
                <td>
                    {{ priceFormatForDisplay(item.price, 2, item.customer_relation?.market_region_id) }}
                </td>
            </template>
            <template #pprice="{item}">
                <td>
                    {{ priceFormatForDisplay(item.pprice, 2, item.customer_relation?.market_region_id) }}
                </td>
            </template>
            <template #status="{item}">
                <td>
                    <DBadge
                        :color="statusColor(item)"
                        shape="rounded"
                    >
                        {{ __(`tools.providerbox.${item.status}`) }}
                    </DBadge>
                    {{ }}
                </td>
            </template>
            <template #created_at="{item}">
                <td>
                    {{ setDateFormat(item.created_at) }}
                </td>
            </template>
        </DTable>
    </DCard>
    <DModal
        is-confirm
        is-small
        :message="__('tools.providerbox.modal.delete_modal_message')"
        :title="__('tools.providerbox.modal.delete_modal_title')"
        :show="showDeleteModal"
        @confirm="deleteItems"
    />
    <DFabs>
        <DFab
            v-if="form.items.length > 0"
            icon="delete"
            label="Delete"
            @click="openDeleteModal"
            @close="showDeleteModal=false"
        />
        <DFab
            icon="plus"
            :label="__('tools.providerbox.invoice_button')"
            @click="generateInvoice"
        />
    </DFabs>
</template>

<script>

import _ from 'lodash'
import priceFormat from '~@/Mixins/priceFormat'

export default {
    name: 'ImportedItemsIndex',
    mixins: [
        priceFormat
    ],
    props: {
        importedItems: {
            type: Object,
            default: () => { return {} }
        },
        modules: {
            type: Array,
            default: () => { return [] }
        },
        status: {
            type: Array,
            default: () => { return [] }
        },
        filters: {
            type: Object,
            default: () => {
                return {
                    dateFrom: null,
                    dateTo: null,
                    modules: [],
                    status: null,
                    customerId: null
                }
            }
        }
    },
    data () {
        return {
            form: this.$inertia.form({
                items: []
            }),
            fields: [
                { key: 'checkbox', label: '' },
                { key: 'id', label: this.__('tools.providerbox.table.id') },
                { key: 'created_at', label: this.__('tools.providerbox.table.date') },
                { key: 'module', label: this.__('tools.providerbox.table.module') },
                { key: 'description', label: this.__('tools.providerbox.table.description') },
                { key: 'start', label: this.__('tools.providerbox.table.start') },
                { key: 'from', label: this.__('tools.providerbox.table.from') },
                { key: 'to', label: this.__('tools.providerbox.table.to') },
                { key: 'package', label: this.__('tools.providerbox.table.package') },
                { key: 'customer', label: this.__('tools.providerbox.table.customer') },
                { key: 'customer_id', label: this.__('tools.providerbox.table.customer_id') },
                { key: 'group', label: this.__('tools.providerbox.table.group') },
                { key: 'price', label: this.__('tools.providerbox.table.price') },
                { key: 'pprice', label: this.__('tools.providerbox.table.pprice') },
                { key: 'status', label: this.__('tools.providerbox.table.status') }
            ],
            dataFilters: _.cloneDeep(this.filters),
            allItems: false,
            showDeleteModal: false
        }
    },
    computed: {
        moduleOptions () {
            const modules = _.cloneDeep(this.modules)

            for (const module in modules) {
                if (this.filters.modules.includes(modules[module].value)) {
                    modules[module].selected = true
                }
            }

            return modules
        },
        newImportedItems () {
            const newImportedItems = this.importedItems.filter(item => item.status === 'new')

            return newImportedItems.length
        }
    },
    methods: {
        changePage () {
            const queryParameters = Object.fromEntries(Object.entries(this.dataFilters).filter(([_, v]) => v))

            this.$inertia.get(this.$route('tools.providerbox.imported-items', {
                saveFilters: true
            }), queryParameters)
        },
        openDeleteModal () {
            this.showDeleteModal = true
        },
        deleteItems () {
            this.form.delete(this.$route('tools.providerbox.delete'))
            this.showDeleteModal = false
            this.form.items = []
            this.allItems = false
        },
        updateCheckboxArray (item, allowRemoving = true) {
            if (this.form.items.includes(item) && allowRemoving) {
                this.form.items = this.form.items.filter(value => value !== item)
            } else if (!this.form.items.includes(item)) {
                this.form.items.push(item)
            }
        },
        updateAllCheckboxes () {
            this.importedItems.forEach(item => {
                if (item.status === 'new') {
                    this.updateCheckboxArray(item.id, !this.allItems)
                }
            }
            )
        },
        statusColor (item) {
            switch (item.status) {
                case 'invoiced':
                    return 'success'
                case 'new':
                case 'invoice_pending':
                    return 'warning'
            }
        },
        resetFilters () {
            this.dataFilters.dateFrom = null
            this.dataFilters.dateTo = null
            this.dataFilters.modules = []
            this.dataFilters.status = null
            this.dataFilters.customerId = null
            const queryParameters = Object.fromEntries(Object.entries(this.dataFilters).filter(([_, v]) => v))
            this.$inertia.get(this.$route('tools.providerbox.imported-items', {
                saveFilters: true,
                defaultFilters: true
            }), queryParameters)
        },
        updateSelectedModules (values) {
            this.dataFilters.modules = values
        },
        generateInvoice () {
            this.form.post(this.$route('tools.providerbox.generate-invoices'), {
                onSuccess: () => {
                    this.form.items = []
                    this.allItems = false
                }
            })
        }
    }
}
</script>

<style scoped>
    .absolute-checkbox {
        z-index: 1000;
        position: relative;
        top: 30px;
        left: 12px;
    }
</style>
